export const getAvatarUrl = (avatarFileName?: string): string | undefined => {
	if ( ! avatarFileName ) return undefined;

	return `${process.env.REACT_APP_API_BASE_URL}/uploads/avatars/${ avatarFileName }`;
};